module.exports = __webpack_public_path__ + "7602c0616c6c6d569bb41612e89a6dea.png";